<template>
  <div class="page">
    <AppWrapper :disabledDates="disabledDates" />
    <!-- <LanguageSwitcher /> -->
  </div>
</template>

<script>
import { computed } from 'vue'
import AppWrapper from './components/AppWrapper.vue'
// import LanguageSwitcher from "./components/LanguageSwitcher.vue";

export default {
  name: 'App',
  components: {
    AppWrapper
    // LanguageSwitcher,
  },
  data() {
    return {
      reservation: this.reservation,
      progress: this.progress,
      //disabledDates: null,
      loader: null
    }
  },
  provide() {
    return {
      reservation: computed(() => this.reservation),
      progress: computed(() => this.progress)
    }
  }
}
</script>

<style>
@import 'https://www.krallerhof.com/typo3conf/ext/wx_sitepackage/Resources/Public/Css/fonts.css';
@import './assets/css/booking.css';
</style>
